(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["login/includes/_suggestion.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "country_name")) {
output += "\n    ";
output += runtime.suppressValue((lineno = 1, colno = 8, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["You recently accessed our %(country_name)s site. Do you want to go there?",runtime.makeKeywordArgs({"country_name": runtime.contextOrFrameLookup(context, frame, "country_name")})])), env.opts.autoescape);
output += " <a class=\"de-login-2020__message-content-link\" href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "recommended_url_domain"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "recommended_url_domain"), env.opts.autoescape);
output += "?</a>\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "reason") == "last_subdomain") {
output += "\n    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 3, colno = 8, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Welcome back! It looks like you usually sign in somewhere else. Try accessing Discovery Education at <a class=\"de-login-2020__message-content-link\" href=\"%(button_url)s\">%(button_label)s</a>",runtime.makeKeywordArgs({"button_url": runtime.contextOrFrameLookup(context, frame, "recommended"),"button_label": runtime.contextOrFrameLookup(context, frame, "recommended_url_domain")})]))), env.opts.autoescape);
output += "\n";
;
}
else {
output += "\n    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 5, colno = 8, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Page not familiar? Try accessing Discovery Education at <a class=\"de-login-2020__message-content-link\" href=\"%(recommended_url_domain)s\">%(recommended_url_domain)s</a>",runtime.makeKeywordArgs({"recommended_url_domain": runtime.contextOrFrameLookup(context, frame, "recommended_url_domain")})]))), env.opts.autoescape);
output += "\n";
;
}
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/login/templates/includes/_suggestion", function(){});

